<script setup lang="ts">
const props = defineProps({
  documentId: {
    type: String,
    required: true,
  },
});

const saveDocument = async (submittedDocument: SubmittedDocument) => {
  await useDocuments().updateDocument(submittedDocument);
};

const onSubmitted = async () => {
  // update the document state to student completed
  await useDocuments().updateDocumentStateById(
    props.documentId,
    DocumentState.studentCompleted
  );

  window.location.reload();
};

const submittedDocumentStore = useSubmittedDocument(props.documentId)();
const { revision } = storeToRefs(submittedDocumentStore);
</script>

<template>
  <div class="h-full flex flex-col gap-4 overflow-hidden">
    <DocumentWrapper
      :document-id="documentId"
      :mode="DocumentViewMode.student"
      :is-companion-mode="true"
      @on-submitted="onSubmitted"
    >
      <template #app-bar="{ submittedDocument }">
        <!-- Top Bar (Metadata & Actions) -->
        <div
          class="bg-white border-b border-gray-200 p-2 flex items-center gap-2 shadow-sm z-10"
        >
          <div class="flex flex-row items-center gap-2">
            <NuxtLink :to="useCreateCompanionPortalRoute('/')">
              <BaseIconButton>
                <icon name="material-symbols:home" size="24" />
              </BaseIconButton>
            </NuxtLink>
            <div class="h-6 w-[1px] bg-gray-300 mx-1"></div>
          </div>
          <div
            v-if="submittedDocument"
            class="flex-1 font-medium text-gray-800"
          >
            <input
              v-model="submittedDocument.name"
              class="text-sm font-semibold bg-transparent border border-transparent hover:border-gray-200 focus:border-primary focus:bg-white rounded px-2 py-0.5 outline-none transition-all w-full max-w-[300px]"
              @keyup.enter="saveDocument(submittedDocument)"
              @change="saveDocument(submittedDocument)"
            />
            <!-- <span
          v-if="submission.checklist"
          class="text-[10px] text-gray-500 font-normal uppercase tracking-wide"
          >{{ submission.checklist }}</span
        > -->
          </div>

          <!-- Left side spacer or back button if needed -->
          <div class="flex items-center justify-center gap-2 pr-2">
            <CompanionTutorial icon-only />
            <ReportProblemButton
              source="companion"
              :show-urgency="false"
              :show-email="true"
              variant="icon"
            />
            <DocumentEditingHistoryButton
              v-if="revision?.id"
              :submitted-document-id="documentId"
              :revision-id="revision?.id"
            />
            <BaseIconButton
              @click="$emit('toggle-sidebar')"
              variant="text"
              tooltip="Toggle Submissions List"
            >
              <BaseIconListPlus class="w-5 h-5 text-gray-600" />
            </BaseIconButton>
          </div>
        </div>
      </template>
    </DocumentWrapper>
  </div>
</template>
